import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

import { useOrganizationPockets } from "../hooks/useOrganizationPockets";
import { usePocketsVisibility } from "../hooks/usePocketsVisibility";
import { PocketPreviewPill } from "./PocketPreviewPill";

export const PocketsPreviewRow = () => {
  const { t } = useTranslations("cards");
  const navigate = useNavigate();

  const { visible, isLoading: visibilityLoading } = usePocketsVisibility();
  const { pockets, isLoading } = useOrganizationPockets();

  if (visibilityLoading || !visible) return null;
  if (isLoading || pockets.length === 0) return null;

  return (
    <section className="space-y-2">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div>
          <h2 className="text-base font-semibold leading-tight text-foreground">
            {t("cards_pockets_preview_title")}
          </h2>
          <p className="mt-0.5 text-xs text-muted-foreground">{t("cards_pockets_preview_subtitle")}</p>
        </div>
        <ColocaButton variant="default" size="sm" onClick={() => navigate("/app/cards/pockets")}>
          {t("cards_pockets_preview_view_all")}
        </ColocaButton>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-1">
        {pockets.map((pocket) => (
          <PocketPreviewPill
            key={pocket.id}
            pocket={pocket}
            onOpen={(id) => navigate(`/app/cards/pockets/${id}`)}
          />
        ))}
        <button
          type="button"
          onClick={() => navigate("/app/cards/pockets")}
          className="inline-flex w-[160px] shrink-0 items-center justify-center gap-1.5 rounded-xl border border-dashed border-border bg-card text-sm text-muted-foreground transition-colors hover:border-ring/40 hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <Plus className="h-3.5 w-3.5" />
          {t("pocket_new_button")}
        </button>
      </div>
    </section>
  );
};
